import React from 'react';

import { CustomerServiceManagementIcon } from '@atlaskit/logo/customer-service-management/icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <CustomerServiceManagementIcon size="xsmall" label="" />;

export const useCustomerServiceManagement = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.CUSTOMER_SERVICE_MANAGEMENT,
		analyticsName: Products.CUSTOMER_SERVICE_MANAGEMENT,
		...options,
	});
